import { render } from "./WebPhone.vue?vue&type=template&id=169fe480&scoped=true"
import script from "./WebPhone.vue?vue&type=script&lang=js"
export * from "./WebPhone.vue?vue&type=script&lang=js"

import "./WebPhone.vue?vue&type=style&index=0&id=169fe480&scoped=true&lang=css"

import exportComponent from "/home/ubuntu/Videos/call-center-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-169fe480"]])

export default __exports__